import { FC } from 'react'
import { useTranslation } from 'next-i18next'

import { selectShouldDisableUserInteraction } from '~/bootcamp/slices/bootcamp-activity.slice'
import { useAppSelector } from '~/redux/hooks'
import { ActivityActionButtons } from '~/bootcamp/Activities/types/activities.types'

import ActivityAnswerButton from '~/bootcamp/components/ActivityAnswerButton'

const QuizSubmitButton: FC<ActivityActionButtons> = (props) => {
  const shouldDisableUserInteraction = useAppSelector(selectShouldDisableUserInteraction)
  const { t } = useTranslation('bootcampQuiz')
  if (!props) return <></>

  const { formValid, submitAnswerAction } = props

  const submitButton = (): React.ReactElement => {
    return (
      <ActivityAnswerButton
        className="w-35 text-white"
        disabled={!formValid || shouldDisableUserInteraction}
        onClick={() => {
          submitAnswerAction()
        }}
        size="small"
        type="submit"
      >
        {t('check')}
      </ActivityAnswerButton>
    )
  }

  return <div className="space-x-3 flex items-center justify-center">{submitButton()}</div>
}

export default QuizSubmitButton
